export default class MenuBar {
    static init(): void {
       // Funkce pro změření výšky divu s třídou .js-menu-bar a nastavení top pro .navbar a .navbar-mobile
        function updateNavbarTop() {
            const menuBarElement = document.querySelector('.js-menu-bar');
            const navbarElement = document.querySelector('.navbar') as HTMLElement;
            const navbarMobileElement = document.querySelector('.navbar-mobile') as HTMLElement;
            const homepageHeaderSlider = document.querySelector('.header-slider') as HTMLElement;

            if (menuBarElement) {
                const menuBarHeight = menuBarElement.clientHeight;

                if (navbarElement) {
                    navbarElement.style.top = `${menuBarHeight}px`;
                    
                    if (homepageHeaderSlider) {
                        homepageHeaderSlider.classList.add('menu-bar-is-active');
                    }
                }

                if (navbarMobileElement) {
                    navbarMobileElement.style.top = `${69 + menuBarHeight}px`;
                }
            }
        }

        // Inicialní kontrola při načtení stránky
        updateNavbarTop();

        // Přidání posluchače na událost změny velikosti okna
        window.addEventListener('resize', updateNavbarTop);
    }
}